<template>
  <div class="container caser">
    <h2>{{ $t('thankYouPage.noHasAseguradoTuEntrada') }}</h2>
    <div class="caser-info">
      <p>{{ $t('payment.aseguradoPor') }}</p>
      <img class="image"
           :src="require('@/assets/images/caser_white.png')"
           alt="" />
    </div>
    <nuxt-link :to="`/es-es/asegura-tu-entrada/pago`"
               :title="$t('userTickets.descargarEntradas')"
               class="btn transparent">{{ $t('thankYouPage.aseguraTuEntrada') }}</nuxt-link>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
@import './banner-caser.sass';
</style>
